import { ExternalMcpAuthMethod } from 'lauria/types/externalMcp'

export const EXTERNAL_MCP_AUTH_METHOD_OPTIONS: {
  value: ExternalMcpAuthMethod
  labelKey: string
}[] = [
  {
    value: 'credential',
    labelKey: 'prompts.form.advanced.mcp.authMethodOptions.credential',
  },
]
